import { useAuth } from "@/contexts/auth/AuthContext";
import ArrowRight from "@/components/icons/ArrowRight";
import {
  StyledButton,
  ButtonTypes,
  ButtonSizes,
  IconTypes,
} from "../StyledButton";

export const AntiHero = () => {
  const { user, openLoginPrompt } = useAuth();
  return !!user ? (
    <div></div>
  ) : (
    <div className="flex h-[300px] w-full flex-col justify-center self-center bg-BG-20 bg-[url('/assets/homepage/homepage_sign_in_promo.png')] bg-auto bg-center bg-no-repeat text-center medium:h-[400px]">
      <div className="">
        <p className="mx-4 mb-8 max-w-[906px] font-teodor text-[40px] font-normal leading-tight text-black medium:mx-auto medium:mb-10 medium:text-[64px]">
          Get started with the XQ Competencies and activities today
        </p>
        <StyledButton
          buttonType={ButtonTypes.Primary}
          size={ButtonSizes.Medium}
          iconType={IconTypes.Right}
          onClick={() => openLoginPrompt("HP_anti_hero")}
          className="w-fit medium:h-16 medium:pl-6 medium:pr-4"
        >
          <span className="hidden medium:inline">Sign in to get started</span>
          <span className="medium:hidden">Get started</span>
          <ArrowRight fill="#FFFFFF" />
        </StyledButton>
      </div>
    </div>
  );
};
